var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../components/UnlinkedApplicationForm";
import { Button, Radio } from "@savvyinsure/react-ui";
import { saveDownPaymentBudget, } from "../../../features/unlinked-application/unlinkedApplicationSlice";
import { convertCentsToDollars, convertDollarsToCents, } from "../../../lib/util";
import AppBody from "../../../components/AppBody";
import Header from "../../../components/Header";
import { PHASE } from "../../../routeConfig";
import { completedPage } from "../../../lib/Avo";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
var DEFAULT_DOWN_PAYMENT_BUDGET_CENTS = 12500;
export default function UnlinkedApplicationAutoDownPaymentPage() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var _a = useForm(), register = _a.register, handleSubmit = _a.handleSubmit, errors = _a.formState.errors;
    var initialDownPaymentOption = useAppSelector(function (state) {
        var premium = state.unlinkedApplication.auto.premium;
        var premiumCents = convertDollarsToCents(premium !== null && premium !== void 0 ? premium : 0);
        return premiumCents
            ? Math.ceil(premiumCents / 5) * 5
            : DEFAULT_DOWN_PAYMENT_BUDGET_CENTS;
    });
    var dispatch = useAppDispatch();
    var push = useHistory().push;
    var downPaymentBudgetInput = register("downPaymentBudgetCents", {
        required: true,
    });
    var options = [
        [
            "$".concat(convertCentsToDollars(initialDownPaymentOption), " or less"),
            { min: 0, max: initialDownPaymentOption },
        ],
        [
            "Between $".concat(convertCentsToDollars(initialDownPaymentOption + 100), " and $").concat(convertCentsToDollars(initialDownPaymentOption * 2)),
            {
                min: initialDownPaymentOption + 100,
                max: initialDownPaymentOption * 2,
            },
        ],
        [
            "Between $".concat(convertCentsToDollars(initialDownPaymentOption * 2 + 100), " and $").concat(convertCentsToDollars(initialDownPaymentOption * 6)),
            {
                min: initialDownPaymentOption * 2 + 100,
                max: initialDownPaymentOption * 6,
            },
        ],
        [
            "$".concat(convertCentsToDollars(initialDownPaymentOption * 6 + 100), " or more"),
            { min: initialDownPaymentOption * 6 + 100, max: 0 },
        ],
    ];
    var onSubmit = handleSubmit(function (data) {
        var selectedOption = data.downPaymentBudgetCents;
        var _a = selectedOption.split(","), min = _a[0], max = _a[1];
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: selectedOption, optionSelected: selectedOption }));
        dispatch(saveDownPaymentBudget({ min: Number(min), max: Number(max) }));
        push(PHASE.UNLINKED_APPLICATION_AUTO_MILITARY);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement(AppBody, { onSubmit: onSubmit, as: "form" },
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, null,
                React.createElement(UnlinkedApplicationForm.Header, null, "How much can you afford to pay up front?"),
                React.createElement("p", { className: "mb-4 mt-1 text-base text-black-300" }, "Extra savings are usually available if you can pay more up front, such as by paying for 2 months or even 6 months in advance."),
                React.createElement("div", { className: "mb-4 space-y-2" }, options.map(function (_a) {
                    var label = _a[0], value = _a[1];
                    return (React.createElement(Radio, __assign({ key: label, variant: "contained", label: label, value: "".concat(value.min, ",").concat(value.max) }, downPaymentBudgetInput)));
                })),
                React.createElement(Button, null, "Continue"),
                errors.downPaymentBudgetCents ? (React.createElement("p", { className: "mt-2 text-center text-sm font-semibold text-red" }, "Please select a down payment option")) : null))));
}
